import { render, staticRenderFns } from "./ItemClass.vue?vue&type=template&id=581de37d&scoped=true"
import script from "./ItemClass.vue?vue&type=script&lang=js"
export * from "./ItemClass.vue?vue&type=script&lang=js"
import style0 from "./ItemClass.vue?vue&type=style&index=0&id=581de37d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581de37d",
  null
  
)

export default component.exports